// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__38k7F","notes":"Notes_notes__2wTjD","note":"Notes_note__3Hk_n","markdown":"Notes_markdown__3s1WF"};